import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import { visitsSearchFields } from '../utils/searchFields';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import Alert from "../../../baseApp/shared/components/alerts/Alert";
import IconButton from './../../../baseApp/shared/components/others/IconButton';
import UserHasPermission, { appModules, modulesActions } from '../../../baseApp/roles/components/UserHasPermission';

const VisitsPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    data = [],
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    alert,
    sort: {
        property,
        direction
    },
    onPageChange,
    onPageSizeChange,
    handleCheckoutClicked = () => { },
    handleAddButtonClicked = () => { },
    buildingList = []
}) => {

    const columns = [{
        Header: I18n.t("visits.list.visitorName"),
        accessor: "visitor.name",
        sortable: true
    }, {
        Header: I18n.t("visits.list.email"),
        id: "visitor.email",
        accessor: visit => visit.visitor.email,
        sortable: true
    }, {
        Header: I18n.t("visits.list.date"),
        accessor: visit => visit.checkInDate,
        id: "checkInTimestamp",
        sortable: true
    }, {
        Header: I18n.t("visits.list.checkInTime"),
        accessor: "checkInTime",
    }, {
        Header: I18n.t("visits.list.building"),
        id: "building.name",
        accessor: visit => visit.entity.name,
        sortable: true
    }, {
        Header: I18n.t("visits.list.visitHost"),
        accessor: "visitHost",
        sortable: true
    }];

    return <div className="page_background">
        <Alert
            {...alert}
        />
        <SearchForm
            content={visitsSearchFields(searchFieldsValues, buildingList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            hideAddButton={false}
            appModule={appModules.VISIT}
        />
        <div>
            <DataTable
                hasEdit={false}
                hasDelete={false}

                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasRowSelector={true}
                customMultiSelectOptions={[
                    (selectedEntries, numberOfSelectedEntries) =>
                        buildCheckoutButton(selectedEntries, numberOfSelectedEntries, handleCheckoutClicked)
                ]}
                hasStatusBar={false}
                rowIsClickable={false}
            />
        </div>
    </div>
};

function buildCheckoutButton(selectedEntries, numberOfSelectedEntries, handleCheckoutClicked) {
    return (
        <UserHasPermission
            appModule={appModules.CHECK}
            action={modulesActions.OUT}
        >
            <IconButton
                textMode={true}
                alt={I18n.t('visits.list.manualCheckOut')}
                classes="check-out-btn ml-2"
                disabled={numberOfSelectedEntries === 0}
                handleIconClick={() => handleCheckoutClicked(selectedEntries)}
            />
        </UserHasPermission>
    );
}

VisitsPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    handleCheckoutClicked: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
    onFetchData: PropTypes.func,
};

export default VisitsPage;
